export const getRandomIntByRange = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const remToPx = (rem) => {
  if (typeof window === `undefined`) {
    return rem;
  }

  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export function splitStringToParagraphs(string, className) {
  if (!className) {
    className = ``;
  }

  const splitText = string?.split(/\r?\n/);
  const jsx = [];

  splitText?.forEach((row, index) => {
    const rowIndex = index;

    if (row !== ``) {
      jsx.push(
        <p
          key={`split-text-${rowIndex}`}
          className={className}
          dangerouslySetInnerHTML={{ __html: row }}
        />
      );
    }
  });

  return jsx;
}

export const getFallbackImageSrc = (image) =>
  image?.asset?.gatsbyImageData?.images?.fallback?.src || null;

export const allArrayItemsAreInAnotherArray = (arr1, arr2) => {
  for (let i = 0; i < arr1.length; i++) {
    if (!arr2.includes(arr1[i])) {
      return false;
    }
  }

  return true;
};

export const isBrowser = typeof window !== `undefined`;

export const parsePixelsToNumber = (pixels) => {
  const removePx = pixels.replace(`px`, ``);
  const numberValue = parseInt(removePx);
  return numberValue;
};

export const calculatePreDiscountPrice = (
  postDiscountPrice,
  discountPercentage
) => {
  const discountRatio = discountPercentage / 100;
  const inverseRatio = 1 - discountRatio;
  const preDiscountPriceFloat = postDiscountPrice / inverseRatio;
  const preDiscountPrice = preDiscountPriceFloat.toFixed(2);
  const differenceFloat = preDiscountPrice - postDiscountPrice;
  const difference = differenceFloat.toFixed(2);
  return { preDiscountPrice, difference };
};

export const calculatePostDiscountPrice = (
  preDiscountPrice,
  discountPercentage
) => {
  const discountRatio = discountPercentage / 100;
  const postDiscountPriceFloat =
    preDiscountPrice - preDiscountPrice * discountRatio;
  const postDiscountPrice = postDiscountPriceFloat.toFixed(2);
  const differenceFloat = preDiscountPrice - postDiscountPrice;
  const difference = differenceFloat.toFixed(2);
  return { postDiscountPrice, difference };
};

export const scrollToTop = (smooth) => {
  if (typeof window !== `undefined`) {
    window.scrollTo({
      top: 0,
      behavior: smooth ? `smooth` : `auto`
    });
  }
};
